module.exports = __webpack_public_path__ + "img/industryScore2.406e6477.svg";